//@flow

export const CommerceRankingOption = {
  DEFAULT: 'DEFAULT',
  PRODUCT: 'PRODUCT',
  PRICE_HIGH_TO_LOW: 'PRICE_HIGH_TO_LOW',
  PRICE_LOW_TO_HIGH: 'PRICE_LOW_TO_HIGH',
  ARRIVAL_MOST_RECENT: 'ARRIVAL_MOST_RECENT',
  ARRIVAL_LEAST_RECENT: 'ARRIVAL_LEAST_RECENT',
};

export const StorefrontSearchSortTypeList = [
  'Default',
  'Price low to high',
  'Price high to low',
  'Newest',
];

export const StorefrontSearchSortTypeDefaultValue = 'Default';

export const StorefrontSearchSortTypeNameMap = {
  Default: CommerceRankingOption.DEFAULT,
  'Price high to low': CommerceRankingOption.PRICE_HIGH_TO_LOW,
  'Price low to high': CommerceRankingOption.PRICE_LOW_TO_HIGH,
  Newest: CommerceRankingOption.ARRIVAL_MOST_RECENT,
};
